import { render, staticRenderFns } from "./BlogPostsSidebarSocial.vue?vue&type=template&id=e9a783b6&scoped=true&"
import script from "./BlogPostsSidebarSocial.vue?vue&type=script&lang=js&"
export * from "./BlogPostsSidebarSocial.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostsSidebarSocial.vue?vue&type=style&index=0&id=e9a783b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a783b6",
  null
  
)

export default component.exports